<template>
<div class="form-sections">
    <slot></slot>
</div>
</template>

<script>
export default {
  name: 'FormSections',
};
</script>

<style scoped lang="scss">

</style>
